import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const EventTileGroupCarousel = (props) => {
  const { children } = props;

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
  };

  return (
    <Slider {...sliderSettings}>
      {children?.map((child, index) => (
        <div className="event-tile-col" key={index} data-testid="mobile-tile">
          {child}
        </div>
      ))}
    </Slider>
  );
};

EventTileGroupCarousel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
